var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "accordion",
    attrs: {
      "role": "tablist"
    }
  }, [_c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "p-1 raftjs-b4",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: _vm.id,
      expression: "id"
    }],
    staticClass: "raftjs-b4",
    attrs: {
      "block": "",
      "variant": "info"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n        "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.collapsed,
      expression: "collapsed"
    }],
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "width": "10",
      "height": "6",
      "viewBox": "0 0 10 6",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.52827 0.195262C0.788619 -0.0650874 1.21073 -0.0650874 1.47108 0.195262L4.99967 3.72386L8.52827 0.195262C8.78862 -0.0650874 9.21073 -0.0650874 9.47108 0.195262C9.73143 0.455612 9.73143 0.877722 9.47108 1.13807L5.47108 5.13807C5.21073 5.39842 4.78862 5.39842 4.52827 5.13807L0.52827 1.13807C0.26792 0.877722 0.26792 0.455612 0.52827 0.195262Z",
      "fill": "#00008C"
    }
  })])])], 1), _vm._v(" "), _c('b-collapse', {
    class: {
      grid: _vm.isGrid
    },
    staticStyle: {
      "padding-top": "0.5rem"
    },
    attrs: {
      "visible": !_vm.collapsed,
      "id": _vm.id,
      "accordion": "incident-investigation-drawers",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', [_vm._t("accordionFormFields")], 2)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }